<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
    >
    <Menu />
    </v-navigation-drawer>

    <v-app-bar
      app
      color="blue"
      dark
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Beerstorium Ticketing</v-toolbar-title>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import Menu from './components/Menu'
export default {
  components: {
    'Menu': Menu
  },
  props: {
    source: String
  },
  data: () => ({
    drawer: null
  })
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Montserrat&display=swap');
*{
  font-family: 'Montserrat', sans-serif;
}
.pointer {
  cursor: pointer;
}
.v-toolbar__content{
  background: #00585F;
  .v-toolbar__title{
    text-transform: uppercase;
    font-weight: 900;
    letter-spacing: 1px;
    text-align: center;
    padding: 0;
    margin: auto;
    color: #FBF1D7;
  }
}
.v-main{
  background: url('assets/beerstorium-screen-app.jpg?v=3')no-repeat center;
  background-size: cover;
}
.mega-btn.v-btn--fab.v-size--x-large{
  background-color: #00585F !important;
  margin: auto;
  height: 200px;
  width: 200px;
  bottom: 40px;
  left: calc(50% - 100px);
  .v-icon{
    height: 84px;
    font-size: 84px;
    width: 84px;
    color: #FBF1D7;
  }
}
.qrcode-wrap,.inside{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  video{
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
}
.over-title{
  color: #fff;
  text-transform: uppercase;
  position: absolute;
  top: 50px;
  left:0;
  right:0;
  padding: 0 20px;
  text-align: center;
  z-index: 999999;
}
.btn-dev{
  position: fixed !important;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 70px !important;
}
.found-scan{
  padding: 35px;
  background-color: #fff;
  border-radius: 10px;
  h1,h2{
    text-transform: uppercase;
    text-align: left;
    font-size: 24px;
    font-weight: 300;
  }
}
.resume-tech{
  li{
    font-size: 18px;
    line-height: 30px;
    color: #fff;
  }
}
.badge-dub{
  margin-top: 25px;
}
.tech-bix{
li{
    line-height: 45px;
  }
}
.scan-again{
  float: right;
  background-color:#FBF1D7 !important;
  padding: 20px 50px !important;
  height: auto !important;
}
.b-separator{
  position: relative;
  &::after{
    display: block;
    height: 1px;
    width: auto;
    content:"";
    position: absolute;
    bottom: 0;
    left:20px;
    right:20px;
    background: #FBF1D7
  }
}
.scan-accept{
  float: left;
  padding: 20px 50px !important;
  height: auto !important;
}
</style>
